import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './views/login/login.component';
import { FooterComponent } from './components/footer/footer.component';
import { SearchpageComponent } from './views/searchpage/searchpage.component';
import { UnauthorizedComponent } from './views/unauthorized/unauthorized.component';
import { JwtModule } from '@auth0/angular-jwt';
import { MatDialogModule } from "@angular/material/dialog";
import { ConfirmationDialogComponent } from "./components/confirmation-dialog/confirmation-dialog.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { ViewfileComponent } from "./components/viewfile/viewfile.component";
import { SafePipe } from './pipes/safe.pipe';
import { DataService } from './services/data.service';
import { SpeechRecognitionService } from './services/speechRecognition.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CompetenciespageComponent } from './views/competencies_page/competencies.component';

import { ChatbotService } from './services/chatbot.service';
import { AzureAuthService } from './services/azure-auth.service';
import { ChatbotDataService } from './services/chatbotData.service';
import { UserListComponent } from './views/users/user-list/user-list.component';
import { PendingUsersComponent } from './views/users/pending-users/pending-users.component';
import { UserService } from './services/user.service';
import { UserComponent } from './views/users/user/user.component';

// tslint:disable-next-line: max-line-length
import { PaginationComponent } from './components/pagination/pagination.component';
import { CategorybarComponent } from './components/categorybar/categorybar.component';
import { SearchresultsComponent } from './views/searchresults/searchresults.component';
import { SendmaildialogComponent } from './components/sendmaildialog/sendmaildialog.component';
import { InfoDialogComponent } from './components/info-dialog/info-dialog.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ViewMoreComponent } from "./components/view-more/view-more.component";
import { SharedModule } from "./views/shared/shared.module";
import { OrganizationModule } from "./views/organizations/organizations.module";
import { IctsearchresultsComponent } from "./views/ictsearchresults/ictsearchresults.component";
import { ToastrModule } from "ngx-toastr";

import { ItemsListComponent } from "src/app/components/items-list/items-list.component";
import { ItemsGridComponent } from "src/app/components/items-grid/items-grid.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";

import { MatGridList, MatGridListModule } from "@angular/material/grid-list";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTabsModule } from "@angular/material/tabs";
import { CommonModule, DatePipe } from "@angular/common";
import { CompetenciesComponent } from "./views/competencies/competencies.component";
import { SharedcompetencyService } from "./services/sharedcompetency.service";
import { PracticesCarouselComponent } from "./components/practices-carousel/practices-carousel.component";
import { HomeComponent } from "./views/home/home.component";
import { LandingComponent } from "./views/landing-page/landing.component";
import { ProposalRepositoryComponent } from "./views/proposal-repository/proposal-repository.component";
import { ProposalCardsComponent } from "./components/proposal-cards/proposal-cards.component";
import { TemplatesComponent } from "./views/templates/templates.component";
import { TemplateUploadModalComponent } from "./views/template-upload-modal/template-upload-modal.component";
import { UpdateTemplateModal } from "./views/templates/update-template-modal.component";
import { SizeConversonPipe } from "./shared/size-converson.pipe";
import { DeleteTemplateModal } from "./views/templates/delete-template-modal.component";
import { SkillRepositoryComponent } from "./views/skill-repository/skill-repository.component";
import { SkillRepoEmployeesComponent } from "./views/skill-repo-employees/skill-repo-employees.component";
import { SkillRepoEmployeeTilesComponent } from "./views/skill-repo-employee-tiles/skill-repo-employee-tiles.component";
import { ProposalTemplatesComponent } from "./views/proposal-templates/proposal-templates.component";
import { DeleteDialogComponent } from "./components/delete-dialog/delete-dialog.component";
import { EditTemplateModalComponent } from "./components/edit-template-modal/edit-template-modal.component";
import { LoginGuard } from "./auth/login.guard";
import { SearchPageRoutingModule } from "./views/searchpage/searchpage-routing.module";
import { RouterModule } from "@angular/router";
import { AddRolesComponent } from "./views/add-roles/add-roles.component";
import { AddFieldsModule } from "./components/add-fields-dialog/app-add-fields.component";

import { DashboardService } from './views/Dashboard/Dashboad.service';
import { DashboarddemoComponent } from './views/Dashboard1/dashboard1/dashboard.component';
import { AnnouncementsdemoComponent } from './views/Dashboard1/announcements1/announcements.component';
import { LearnNextdemoComponent } from './views/Dashboard1/learn-next1/learn-next.component';
import { LearningsdemoComponent } from './views/Dashboard1/learnings1/learnings.component';
import { ProfileCarddemoComponent } from './views/Dashboard1/profile-card1/profile-card.component';
import { ProfileViewdemoComponent } from './views/Dashboard1/profile-view1/profile-view.component';
import { DataUploadComponent } from './components/dataupload/dataupload.component';
import { DashboarddemoService } from './views/Dashboard1/Dashboad1.service';
import { ConfirmationBackDialogComponent } from './components/confirmation-back-dialog/confirmation-back-dialog.component';
import { CustomTooltipComponent } from './components/custom -tooltip-component/custom-tooltip.component';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { EmployeeDataTableComponent } from './views/employee-data-table/employee-data-table.component';
import { ExcelService } from './services/excel-service.service';
import { } from '@angular/compiler';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from "@angular/material/core";

import { MY_FORMATS } from "./views/project-connects/components/pconnect/pconnect.component";

import { TrainingsTrackerService } from './views/trainings_tracker/trainings_tracker_header/trainings_tracker.service';
import { TrainingsTrackerHeaderComponent } from './views/trainings_tracker/trainings_tracker_header/trainings_tracker_header.component';
import { HeaderComponent } from "./components/header/header.component";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatExpansionModule } from '@angular/material/expansion';
import { RoleGuardGuard } from './auth/role-guard.guard';
import { AuthGuard } from './auth/auth.guard';
import { LoaderinterceptorService } from './interceptors/loaderinterceptor.service';
import { TemplateDocsComponent } from './views/template-docs/template-docs.component';
import { TemplateCreationComponent } from './views/template-creation/template-creation.component';
import { TemplateCategoryModalComponent } from './views/template-category-modal/template-category-modal.component';
import { RatingModalComponent } from './views/rating-modal/rating-modal.component';
import { ViewReviewModalComponent } from './views/view-review-modal/view-review-modal.component';
import { MockupsComponent } from './mockups/mockups.component';
import { EmployeeComponent } from './employee/employee.component';
import { Customer360DashboardComponent } from './components/customer-360/customer360-dashboard/customer360-dashboard.component';
import { CustomerDetailsComponent } from './components/customer-360/customer-details/customer-details/customer-details.component';
import { AddPreferancesComponent } from './views/add-preferances/add-preferances.component';
import { ProjectTechstackComponent } from './project-techstack/project-techstack.component';
import { TechStackGridComponent } from './tech-stack-grid/tech-stack-grid.component';
import { AddDialogComponent } from './components/add-dialog/add-dialog.component';
import { ConfirmationPopupComponent } from './views/employee-details/ConfirmationPopup.component';
import { DialogForCompetencyComponent } from './components/dialog-for-competency/dialog-for-competency.component';
import { LoginIssueComponent } from './views/login-issue/login-issue.component';
import { ProjectDataTableComponent } from './views/competencies/project-data-table/project-data-table.component';
import { TimeStampComponent } from './views/time-stamp/time-stamp.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatRippleModule } from '@angular/material/core';
import { FieldMissingEmployeesComponent } from './views/field-missing-employees/field-missing-employees.component';
import { LoaderService } from './components/loader/loader.service';
import { ConfirmationActionDialogComponent } from './components/confirmation-back-dialog/confirmation-action-dialog/confirmation-action-dialog.component';
import { OrganizationalComplianceCreationComponent } from './views/organizational-compliance-creation/organizational-compliance-creation.component';
import { OrganizationalComplianceComponent } from './views/organizational-compliance/organizational-compliance.component';
import { QuestionExportComponent } from './question-export/question-export.component';
import { QuestionScanningComponent } from './views/question-scanning/question-scanning.component';
import { WarningDialogComponent } from './warning-dialog/warning-dialog.component';
import { LinechartDialogComponent } from './views/time-stamp/linechart-dialog/linechart-dialog.component';
import { DateRangeDialogComponentComponent } from './components/confirmation-back-dialog/date-range-dialog-component/date-range-dialog-component';
import { NgxGraphModule } from '@swimlane/ngx-graph';
//import { ProdocsComponent } from './views/projects/prodocs/prodocs.component';
// import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';

// import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { AuditorDetailsComponent } from './views/Audit/creation/auditor-details/auditor-details.component';
import { AuditdetailsserviceService } from './views/Audit/creation/auditor-details/auditdetailsservice.service';
import { QuestionsTableComponent } from './views/Audit/questions-table/questions-table.component';
import { ProjectOverviewComponent } from './views/Audit/project-overview/project-overview.component';
import { ProjectDisplayComponent } from './views/Audit/project-display/project-display/project-display.component';
import { AddNewCategoryDialog, QuestionMasterComponent } from './views/Audit/question-master/question-master/question-master.component';
import { ProjectDetailComponent } from './components/Audit/project-detail/project-detail.component';
import { ProjectListingComponent } from './views/Audit/project-list/project-listing.component';
import { ProjectSettingsComponent } from './views/Audit/settings/project-settings.component';
import { MaterialModule } from './views/employee/shared/angular-material/material.module';
import { ChartModule } from 'primeng/chart';
import { GenAiMainComponent } from './views/GenAI-POC/gen-ai-main/gen-ai-main.component';
import { AddCommentDialogComponent } from './components/add-comment-dialog/add-comment-dialog.component';
import { ViewCommentsDialogComponent } from './components/view-comments-dialog/view-comments-dialog.component';
import { CreateNEditPocComponent } from './components/create-nedit-poc/create-nedit-poc.component';
import { EmployeeOnboardingComponent } from './views/Dashboard/employee-onboarding/employee-onboarding.component';
import { TechnologyQuestionsComponent } from './views/Audit/question-master/technology-questions/technology-questions.component';
import { AddNewQuestionComponent } from './views/Audit/question-master/add-new-question/add-new-question.component';
import { SubmitDialogComponent } from './views/Audit/project-overview/submit-dialog/submit-dialog.component';
import { CommentsHistoryDialogComponent } from './components/Audit/comments-history-dialog/comments-history-dialog.component';
import { SelectCategoriesComponent } from './views/Audit/creation/auditor-details/select-categories/select-categories.component';
import { PeopleStrongDataUploadComponent } from './views/time-stamp/people-strong-data-upload/people-strong-data-upload.component';
import { EditCompetencyDialogComponent } from './views/field-missing-employees/components/edit-competency-dialog/edit-competency-dialog.component';
import { ViewCompetencyDialogComponent } from './views/field-missing-employees/components/view-competency-dialog/view-competency-dialog.component';
import { ConfirmDialogComponent } from './views/field-missing-employees/components/confirm-dialog/confirm-dialog.component';
import { MaintenancePageComponent } from './views/maintenance-page/maintenance-page.component'
import { TitleCasePipe } from './pipes/title-case.pipe';
import { AccessEmployeeDashboardComponent } from './employee/access-employee-dashboard/access-employee-dashboard.component';
import { TopTrainingListDetailsComponent } from './top-training-list-details/top-training-list-details.component';
import { ModularConfirmDialogComponent } from './views/field-missing-employees/components/modular-confirm-dialog/modular-confirm-dialog.component';
import { GsdSupportDialogComponent } from './gsd-support-dialog/gsd-support-dialog.component';
import { ReminderAndEscalationComponent } from './reminder-and-escalation/reminder-and-escalation.component';
// import { CompetencyInsightsComponent } from './views/competencies/competency-insights/competency-insights.component';
// import { SkillMaturityComponent } from './views/competencies/skill-maturity/skill-maturity.component';
// import { SubCompetenciesSidebarComponent } from './views/competencies/sub-competencies-sidebar/sub-competencies-sidebar.component';
// import { SubCompetenciesContentComponent } from './views/competencies/sub-competencies-content/sub-competencies-content.component';
declare module "@angular/core" {
  interface ModuleWithProviders<T = any> {
    ngModule: Type<T>;
  }
}

export const MY_DATE_FORMAT = {
  parse: {
    dateInput: ["DD/MM/yyyy"], // to accept different input styles from user
  },
  display: {
    dateInput: "DD/MM/yyyy", // display format in input field
    monthYearLabel: 'yyyy MMMM',
    dateA11yLabel: 'MMMM d, y',//'LL',
    monthYearA11yLabel: 'MMMM yyyy'
  },
};
@NgModule({

  declarations: [
    AppComponent,
    LoginComponent,
    MaintenancePageComponent,
    LoginIssueComponent,
    CompetenciespageComponent,
    CustomTooltipComponent,
    FooterComponent,
    UnauthorizedComponent,
    ConfirmationDialogComponent,
    ViewfileComponent,
    SafePipe,
    SendmaildialogComponent,
    InfoDialogComponent,
    ViewMoreComponent,
    IctsearchresultsComponent,
    ItemsListComponent,
    ItemsGridComponent,
    PracticesCarouselComponent,
    HomeComponent,
    LandingComponent,
    ProposalRepositoryComponent,
    ProposalCardsComponent,
    TemplatesComponent,
    TemplateUploadModalComponent,
    UpdateTemplateModal,
    DeleteTemplateModal,
    SizeConversonPipe,
    SkillRepositoryComponent,
    SkillRepoEmployeesComponent,
    SkillRepoEmployeeTilesComponent,
    ProposalTemplatesComponent,
    DeleteDialogComponent,
    EditTemplateModalComponent,
    PaginationComponent,
    SearchpageComponent,
    SearchresultsComponent,
    AddRolesComponent,
    AddFieldsModule,
    TrainingsTrackerHeaderComponent,
    ViewReviewModalComponent,
    DashboarddemoComponent,
    AnnouncementsdemoComponent,
    LearnNextdemoComponent,
    LearningsdemoComponent,
    ProfileCarddemoComponent,
    ProfileViewdemoComponent,
    DataUploadComponent,
    ConfirmationBackDialogComponent,
    EmployeeDataTableComponent,
    ProjectDataTableComponent,
    TemplateDocsComponent,
    TemplateCreationComponent,
    TemplateCategoryModalComponent,
    RatingModalComponent,
    MockupsComponent,
    EmployeeComponent,
    Customer360DashboardComponent,
    CustomerDetailsComponent,
    AddPreferancesComponent,
    ProjectTechstackComponent,
    TechStackGridComponent,
    AddDialogComponent,
    ConfirmationPopupComponent,
    TimeStampComponent,
    FieldMissingEmployeesComponent,
    DialogForCompetencyComponent,
    ConfirmationActionDialogComponent,
    OrganizationalComplianceComponent,
    OrganizationalComplianceCreationComponent,
    QuestionExportComponent,
    QuestionScanningComponent,
    WarningDialogComponent,
    LinechartDialogComponent,
    DateRangeDialogComponentComponent,
    WarningDialogComponent,
    LinechartDialogComponent,
    DateRangeDialogComponentComponent,
    AuditorDetailsComponent,
    QuestionsTableComponent,
    ProjectOverviewComponent,
    ProjectDisplayComponent,
    QuestionMasterComponent,
    ProjectDetailComponent,
    ProjectListingComponent,
    ProjectSettingsComponent,
    GenAiMainComponent,
    AddCommentDialogComponent,
    ViewCommentsDialogComponent,
    CreateNEditPocComponent,
    EmployeeOnboardingComponent,
    TechnologyQuestionsComponent,
    AddNewQuestionComponent,
    AddNewCategoryDialog,
    SelectCategoriesComponent,
    CommentsHistoryDialogComponent,
    SubmitDialogComponent,
    PeopleStrongDataUploadComponent,
    AccessEmployeeDashboardComponent,
    EditCompetencyDialogComponent,
    ViewCompetencyDialogComponent,
    ConfirmDialogComponent,
    TitleCasePipe,
    TopTrainingListDetailsComponent,
    ModularConfirmDialogComponent,
    GsdSupportDialogComponent,
    ReminderAndEscalationComponent
  ],
  exports: [CustomTooltipComponent],

  imports: [
    BrowserModule,
    ChartModule,
    NgbTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    JwtModule,
    SharedModule,
    MatTabsModule,
    CommonModule,
    MatListModule,
    MatButtonModule,
    MatSortModule,
    MatFormFieldModule,
    MatDatepickerModule,
    NgbModule,
    MatDialogModule,
    MatSelectModule,
    MatPaginatorModule,
    MatGridListModule,
    MatRippleModule,
    MatMenuModule,
    ToastrModule.forRoot(),
    MatAutocompleteModule,
    SearchPageRoutingModule,
    RouterModule,
    SlickCarouselModule,
    MatSlideToggleModule,
    MatNativeDateModule,
    MatMomentDateModule,
    NgxGraphModule,
    MatExpansionModule,
  ],
  providers: [
    DataService,
    SpeechRecognitionService,
    ChatbotService,
    DashboardService,
    DashboarddemoService,
    SharedcompetencyService,
    AzureAuthService,
    ExcelService,
    ChatbotDataService,
    UserService,
    MatSnackBar,
    DatePipe,
    LoginGuard,
    TrainingsTrackerService,
    RoleGuardGuard,
    AuthGuard,
    ReactiveFormsModule,
    LoaderService,
    AuditdetailsserviceService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderinterceptorService,
      multi: true,
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },

  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})


export class AppModule {

}

